import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const CalendarSmallScreen = ({ date }) => {
  // Default endDate to today
  const today = new Date();
  const todayFormatted = today.toISOString().split("T")[0];

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState(todayFormatted); // Default to today
  const { t } = useTranslation();
useEffect(() => {
  // Get the stored data object
  const storedData = localStorage.getItem("data");
  if (storedData) {
    try {
      const parsedData = JSON.parse(storedData);
      const sowingDate = parsedData.sowindate;
      if (sowingDate) {
        setStartDate(sowingDate);

        // Ensure backend gets initial values
        date({
          startDate: formatForDisplay(new Date(sowingDate)),
          endDate: formatForDisplay(today),
        });
      }
    } catch (error) {
      console.error("Error parsing stored data:", error);
    }
  } else {
    // If no data, still call backend with empty start date
    date({
      startDate: "",
      endDate: formatForDisplay(today),
    });
  }
}, []);

  // Format date to "YYYY-MM-DD" for input fields
  const formatForInput = (date) => {
    if (!(date instanceof Date) || isNaN(date)) return "";
    return date.toISOString().split("T")[0];
  };

  // Format date to "MM/DD/YYYY" for display
  const formatForDisplay = (date) => {
    if (!(date instanceof Date) || isNaN(date)) return "";
    return (
      ("0" + (date.getMonth() + 1)).slice(-2) +
      "/" +
      ("0" + date.getDate()).slice(-2) +
      "/" +
      date.getFullYear()
    );
  };

  const handleStartDateChange = (e) => {
    const selectedDate = new Date(e.target.value);
    setStartDate(formatForInput(selectedDate));

    // If endDate is empty or before startDate, reset it to today
    if (!endDate || new Date(endDate) < selectedDate) {
      setEndDate(formatForInput(today));
    }

    date({
      startDate: formatForDisplay(selectedDate),
      endDate: formatForDisplay(new Date(endDate) || today), // Default to today if empty
    });
  };

  const handleEndDateChange = (e) => {
    const selectedDate = new Date(e.target.value);
    setEndDate(formatForInput(selectedDate));

    date({
      startDate: formatForDisplay(new Date(startDate)),
      endDate: formatForDisplay(selectedDate),
    });
  };

  return (
    <div className="w-full h-full flex items-center justify-center">
    <div className="flex flex-col space-y-4 w-[80%] bg-gray-100 p-4 rounded-md">
      <p className="text-gray-700 text-[12px] bg-red-200 p-2 rounded">
        <b>{t("Note")}:</b> {t("The selected dates should not be later than today's date. You can only pick a date from 2020 to today's date.")} 
      </p>

      {/* Start Date Input */}
      <div>
        <label htmlFor="start-date" className="block text-sm font-medium">
          {t("Start Date")}
        </label>
        <input
          id="start-date"
          type="date"
          className="mt-1 block w-full p-2 border rounded-md border-black"
          min="2020-01-01"
          value={startDate}
          max={todayFormatted}
          onChange={handleStartDateChange}
        />
      </div>

      {/* End Date Input */}
      <div>
        <label htmlFor="end-date" className="block text-sm font-medium">
          {t("End Date")}
        </label>
        <input
          id="end-date"
          type="date"
          className="mt-1 block w-full p-2 border rounded-md border-black"
          min={startDate || "2020-01-01"}
          max={todayFormatted}
          value={endDate}
          onChange={handleEndDateChange}
          disabled={!startDate}
        />
      </div>
    </div>
  </div>

  );
};

export default CalendarSmallScreen;
